module.exports = __webpack_public_path__ + "img/graph_6.75b2d2a3.png";